<template lang="pug">

div.ui.item.dropdown(ref="dropdownEl")

    //- Avatar als Trigger
    .user-avatar
        .avatar-wrapper
            span.avatar-initial {{ initial }}
            img.avatar-image(v-if="avatarUrl" :src="avatarUrl")
    //- i.icon.bars

    //- Dropdown-Menü
    div.menu

        //- Benutzerinformation (nicht anklickbar)
        div.user-info-header
            div.user-fullname {{ fullName || $auth.username }}
            div.user-role {{ activeRoleLabel }}

        div.divider

        //- Profil bearbeiten (nur für ADMIN, MEDIA_PRODUCTION)
        router-link.item(v-if="canEditProfile" :to="{ name: 'users/update', params: { id: $auth.userId } }")
            i.user.edit.icon
            |  Profil bearbeiten

        //- Rollenswitch (nur wenn mehrere Rollen verfügbar)
        template(v-if="$auth.roleIds.length > 1")
            div.divider
            div.header Rolle wechseln

            a.item(
                v-if='canBeCustomer && activeRole !== "CUSTOMER"'
                v-on:click='changeRole(customerRole)'
            )
                i.exchange.alternate.icon
                |  Kunde

            a.item(
                v-if='canBeAgency && activeRole !== "AGENCY"'
                v-on:click='changeRole(agencyRole)'
            )
                i.exchange.alternate.icon
                |  Agentur

            a.item(
                v-if='canBeSupplier && activeRole !== "SUPPLIER"'
                v-on:click='changeRole(supplierRole)'
            )
                i.exchange.alternate.icon
                |  Lieferant

            a.item(
                v-if='canBeMediaProduction && activeRole !== "MEDIA_PRODUCTION"'
                v-on:click='changeRole("MEDIA_PRODUCTION")'
            )
                i.exchange.alternate.icon
                |  Medienproduktion

            a.item(
                v-if='canBeAdmin && activeRole !== "ADMIN"'
                v-on:click='changeRole("ADMIN")'
            )
                i.exchange.alternate.icon
                |  Administration

        div.divider(v-if="canEditProfile || $auth.roleIds.length > 1")

        //- Logout
        a.item(v-on:click='logout()')
            i.sign.out.icon
            |  Logout


</template>

<script>
    import md5 from 'md5'
    import { default_route } from '@/utils/role'

    //noinspection JSUnusedGlobalSymbols
    export default {

        data() {
            return {}
        },

        computed: {

            activeRole() {
                return this.$auth.activeRole
            },

            activeRoleLabel() {
                const labels = {
                    CUSTOMER: 'Kunde',
                    AGENCY: 'Agentur',
                    SUPPLIER: 'Lieferant',
                    MEDIA_PRODUCTION: 'Medienproduktion',
                    ADMIN: 'Administrator',
                }
                return labels[this.activeRole] || this.activeRole
            },

            agencyRole() {
                return this.$auth.roleIds.find(role => role.includes('AGENCY'))
            },

            canBeAdmin() {
                return this.$auth.roleIds.includes('ADMIN')
            },

            canBeAgency() {
                return this.$auth.roleIds.includes('AGENCY')
            },

            canBeCustomer() {
                return this.$auth.roleIds.includes('CUSTOMER')
            },

            canBeMediaProduction() {
                return this.$auth.roleIds.includes('MEDIA_PRODUCTION')
            },

            canBeSupplier() {
                return this.$auth.roleIds.includes('SUPPLIER')
            },

            customerRole() {
                return this.$auth.roleIds.find(role => role.includes('CUSTOMER'))
            },

            supplierRole() {
                return this.$auth.roleIds.find(role => role.includes('SUPPLIER'))
            },

            person() {
                return this.$store.getters['persons/byId'](this.$auth.personId)
            },

            email() {
                return this.person ? (this.person.email || '').toLowerCase().trim() : ''
            },

            firstName() {
                return this.person ? (this.person.firstName || '') : ''
            },

            lastName() {
                return this.person ? (this.person.lastName || '') : ''
            },

            fullName() {
                return [this.firstName, this.lastName].filter(Boolean).join(' ')
            },

            initial() {
                const first = this.firstName ? this.firstName.charAt(0).toUpperCase() : ''
                const last  = this.lastName  ? this.lastName.charAt(0).toUpperCase()  : ''
                if (first || last) return first + last
                return (this.$auth.username || '?').charAt(0).toUpperCase()
            },

            canEditProfile() {
                return ['ADMIN', 'MEDIA_PRODUCTION'].includes(this.activeRole)
            },

            // Preferred avatar: MOCO image (avatar_url) if present, otherwise Gravatar fallback.
            avatarUrl() {
                if (this.person && this.person.avatar_url) return this.person.avatar_url
                return this.gravatarUrl
            },

            gravatarUrl() {
                if (!this.email) return ''
                return `https://www.gravatar.com/avatar/${md5(this.email)}?s=40&d=blank`
            },

        },

        methods: {

            async changeRole(role) {
                const token = await this.$auth.changeRole(role)
                const route = default_route(token.activeRoleId)
                const { href } = this.$router.resolve(route)
                window.location.assign(href)
            },

            async logout() {
                await this.$auth.logout()
                window.location.assign('/login')
            }

        },

        created() {
            this.$store.dispatch('persons/loadOneByUserId', { userId: this.$auth.userId })
        },

        mounted() {
            $(this.$el).dropdown()
        }

    }
</script>

<style scoped>
    .ui.item.dropdown {
        padding: 0 !important;
    }
    .user-avatar {
        display: inline-flex;
        align-items: center;
        margin-right: 0.6rem;
    }

    .avatar-wrapper {
        position: relative;
        width: 2rem;
        height: 2rem;
        border-radius: 50%;
        overflow: hidden;
        flex-shrink: 0;
    }

    .avatar-image {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .avatar-initial {
        position: absolute;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #4b5563;
        color: #ffffff;
        font-size: 0.75rem;
        font-weight: 600;
        user-select: none;
    }

    .user-info-header {
        padding: 0.6rem 1rem 0.55rem;
        cursor: default;
        pointer-events: none;
    }

    .user-fullname {
        font-weight: 600;
        font-size: 0.875rem;
        color: #111827;
        line-height: 1.3;
    }

    .user-role {
        font-size: 0.75rem;
        color: #6b7280;
        margin-top: 0.1rem;
        line-height: 1.3;
    }

    /* Vertikale Ausrichtung von Icon + Text in Menüeinträgen */
    ::v-deep .menu .item {
        display: flex !important;
        align-items: center !important;
        line-height: 1 !important;
    }

    ::v-deep .menu .item > i.icon {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        line-height: 1 !important;
        vertical-align: middle !important;
    }
</style>
